import { render, staticRenderFns } from "./AIPluginNotInstalled.vue?vue&type=template&id=404f7aca&"
import script from "./AIPluginNotInstalled.vue?vue&type=script&lang=ts&"
export * from "./AIPluginNotInstalled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports